// extracted by mini-css-extract-plugin
export var productImage = "_wt-0";